 <template id="template-date">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :label="fieldData.label[selectedLanguage]"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden)"
      :class="isPreview ? 'mt-0': 'mt-5'"
      id="collapse-5"
      v-model="collapse"
    >
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional=='1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="fieldData.validationMessage[selectedLanguage]"
          >
            <label v-if="$store.state.rightAlign">
            <span dir='rtl' class="mr-1">  {{label ? label : fieldData.label[selectedLanguage]}} </span>
            {{(form1.enableSectionFieldEnumeration == 1 ? (sectionIndex+1)+'.'+(fieldIndex+1) :'')}}
             <span
                v-if="fieldData.validation && fieldData.validation.required"
                class="required-span"
              >*</span>
            </label>
            
              <label v-else>
              <span
                v-if="fieldData.validation && fieldData.validation.required"
                class="required-span"
              >*</span>
              {{(form1.enableSectionFieldEnumeration == 1 ? (sectionIndex+1)+'.'+(fieldIndex+1) :'')}} {{label ? label : fieldData.label[selectedLanguage]}}
            </label>

            <b-input-group
              v-if="fieldData.allowCurrentDate"
              :class="$store.state.rightAlign ? 'text-right mb-3' : 'text-left mb-3'"
            >
              <Datepicker
                :id="fieldData.id"
                :disabled="isDisabled == 1"
                input-class="custom-date-picker"
                calendar-class="date-calender"
                class="form-control"
                v-model.lazy="name"
                :format="customFormatter"
                :disabled-dates="disabledDatesForCurrent"
                @input="setValue"
                @blur="checkValidate"
                :state="isFocus && fieldData.validation && JSON.parse(fieldData.validation.required) ? !$v.name.required ? false : true : null"
                @focus="isFocus=true"
              ></Datepicker>
              <b-input-group-append v-if="!$store.state.rightAlign">
                <span class="input-group-text" id="basic-addon2">
                  <i class="fa fa-calendar"></i>
                </span>
              </b-input-group-append>
            </b-input-group>

            <b-input-group
              v-else
              :class="$store.state.rightAlign ? 'text-right mb-3' : 'text-left mb-3'"
            >
              <Datepicker
                :id="fieldData.id"
                :disabled="isDisabled == 1"
                input-class="custom-date-picker"
                calendar-class="date-calender"
                class="form-control"
                :format="customFormatter"
                :disabled-dates="disabledDates"
                v-model.lazy="name"
                @input="setValue"
                @blur="checkValidate"
                :state="isFocus && fieldData.validation && JSON.parse(fieldData.validation.required) ? !$v.name.required ? false : true : null"
                @focus="isFocus=true"
              ></Datepicker>
              <b-input-group-append v-if="!$store.state.rightAlign">
                <span class="input-group-text" id="basic-addon2">
                  <i class="fa fa-calendar"></i>
                </span>
              </b-input-group-append>
            </b-input-group>
            <span
              v-if="isFocus && fieldData.validation && !$v.name.required"
              class="text-danger"
            >{{fieldData.validationMessage[selectedLanguage]}}</span>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- show advance field options -->

      <b-modal
        cancel-title="Close"
        @hidden="onUpdateSettings"
        ok-title="save"
        @ok="onSaveData"
        size="xl"
        v-model="showSettings"
        title="Date Advanced Settings"
      >
        <AdvanceDateSettings
          :fieldData="fieldData"
          v-on:toggle-field="showSettings=!showSettings"
          :sectionIndex="sectionIndex"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>
<script>
/* eslint-disable */
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
// import AdvanceDateSettings from "../advanceDateSettingsComponent";
import AdvanceDateSettings from "../advanceSettingsCompenent";
import MenuButtons from "../menuButtons";
import { mapGetters, mapState, mapMutations } from "vuex";
import { EventBus } from "@/event-bus.js";

export default {
  name: "DateGroup",
  components: {
    AdvanceDateSettings,
    MenuButtons,
    Datepicker,
  },
  data() {
    return {
      isHidden: false,
      condition: {},
      isFocus: false,
      isError: false,
      isSuccess: false,
      showSettings: false,
      collapse: true,
      label: undefined,
      placeholder: undefined,
      helperText: undefined,
      name: null,
      disabledDatesForCurrent: {
        to: new Date(),
        from: new Date(),
      },
      disabledDates: {
        to:
          this.fieldData.advance && this.fieldData.advance.disabledMinDateInput
            ? new Date(Date.now() - 864e5)
            : this.fieldData.advance && this.fieldData.advance.minDate
            ? new Date(this.fieldData.advance.minDate)
            : "", // Disable all dates up to specific date
        from:
          this.fieldData.advance && this.fieldData.advance.disabledMaxDateInput
            ? new Date()
            : this.fieldData.advance && this.fieldData.advance.maxDate
            ? new Date(this.fieldData.advance.maxDate)
            : "", // Disable all dates after specific date
      },
    };
  },
  validations: {
    name: {
      required,
    },
  },
  mounted() {
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      if(this.$route.name == "EmployeeComplaintFormPage"){
        this.setCurrentDate();
      }
      this.setFieldValue();
    }
  },

  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (this.fieldData.allowCurrentDate) {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;
          } else {
            if (this.$v && !this.$v.$invalid) {
              this.$store.state.validFields = true;
              this.fieldData.isInValid = false;
            } else {
              this.isFocus = true;
              this.$store.state.validFields = false;
              this.fieldData.isInValid = true;
            }
          }
        }
      }
    });
    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  computed: {
    ...mapGetters(["form1", "selectedLanguage", "userFormSubmitArray"]),
    ...mapState(["toggleAllCoppalse"]),
  },

  watch: {
    toggleAllCoppalse(vlue) {
      this.collapse = vlue;
    },
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),
    setCurrentDate(){
      if(this.fieldData.label['english'] == 'Date of first incident'){
        this.setValue(new Date())
      }
    },
    onUpdateSettings() {
      this.TOGGLE_LOADER(2);
    },

    checkValidate() {
      if (this.name.length >= 3) {
        (this.isError = false), (this.isSuccess = true);
      } else {
        (this.isError = true), (this.isSuccess = false);
      }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements.map((el) => {
              return (this.name = el.postValue || null);
            });
          }
        });

      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage"
      ) {
        if (this.fieldData.allowCurrentDate) {
          this.setValue(new Date());
        }
      }
    },

    setValue(e) {
      const registerData = _.clone(this.$store.state.registerData);

      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.name = e;
        if (e) {
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;

        this.userFormSubmitArray.find((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements[0] = {
              postValue: e,
              postName:
                (this.fieldData.attributes &&
                  this.fieldData.attributes.postName) ||
                "postNameInput",
            };
          }
        });
      }
    },

    customFormatter(date) {
      let customFormat = this.fieldData.format;
      if (customFormat == "default") {
        return moment(date).format("DD-MM-YYYY");
      } else {
        return moment(date).format(customFormat);
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
    },
  },
  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.custom-date-picker {
  width: 100%;
  border: none;
}
.date-picker-right {
  text-align: right !important;
}
.date-picker-left {
  text-align: left !important;
}
.input-group-text-left {
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
}
.custom-date-picker:focus {
  border: none;
}
.date-calender {
  height: 21em;
  width: 500px !important;
  background: #dee2e6 !important;
}
</style>

